// Shared composer i18n — status badges chung cho mọi post form/table.
// Tập trạng thái đồng nhất giữa các platform (published/failed/scheduled/
// processing/draft). Biến thể `form` có icon, `table` không icon — khớp đúng
// wording đang dùng rải rác ở từng platform trước khi gom về components/Composer.
const fragment = {
  vi: {
    'composer.status.form.published': '✓ Đã đăng',
    'composer.status.form.failed': '⚠ Lỗi',
    'composer.status.form.scheduled': '📅 Đã lên lịch',
    'composer.status.form.processing': '⏳ Đang đăng',
    'composer.status.form.draft': '• Nháp',
    'composer.status.table.published': 'Đã đăng',
    'composer.status.table.failed': 'Lỗi',
    'composer.status.table.scheduled': '📅 Đã lên lịch',
    'composer.status.table.processing': '⏳ Đang đăng',
    'composer.status.table.draft': 'Nháp',
  },
  en: {
    'composer.status.form.published': '✓ Published',
    'composer.status.form.failed': '⚠ Failed',
    'composer.status.form.scheduled': '📅 Scheduled',
    'composer.status.form.processing': '⏳ Publishing',
    'composer.status.form.draft': '• Draft',
    'composer.status.table.published': 'Published',
    'composer.status.table.failed': 'Failed',
    'composer.status.table.scheduled': '📅 Scheduled',
    'composer.status.table.processing': '⏳ Publishing',
    'composer.status.table.draft': 'Draft',
  },
};

export default fragment;
